module.exports = __webpack_public_path__ + "static/media/registration-success-icon.bb254264.svg";